import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { type RisrSchemaDisplay } from "./risr-schema-display";
import { RisrSchemaDisplayGroupRenderer } from "./risr-schema-display-group-renderer";

@Component({
    selector: 'risr-schema-display-renderer',
    imports: [CommonModule, RisrSchemaDisplayGroupRenderer],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="display-container">
            <risr-schema-display-group-renderer [field]="display().risrGroup"></risr-schema-display-group-renderer>
        </div>
    `,
})
export class RisrSchemaDisplayRenderer {
    display = input.required<RisrSchemaDisplay>();
}
